import type { EntityType, StaticEntityType } from "@config";
import { Set } from "@library-containers/layers";
import { forwardRef } from "react";
import { useCarouselCtx } from "../../ctx";
import { CarouselItemWrapper } from "./carousel-item-wrapper";

export const CarouselItems = forwardRef<HTMLDivElement>((_, ref) => {
  const { editorData, sets, comboId, comboSettings, comboLayers } =
    useCarouselCtx();

  return (
    <div className="tw-relative tw-flex tw-h-auto tw-w-full">
      <div
        className="swiper carousel-items tw-w-full tw-overflow-hidden md:tw-pb-6"
        ref={ref}
      >
        <div className="swiper-wrapper tw-items-center">
          {sets.map((set, idx) => (
            <CarouselItemWrapper key={set.id} set={set}>
              {editorData ? (
                <editorData.EditorItem set={set as EntityType} />
              ) : (
                <Set
                  entity={{
                    ...(set as StaticEntityType),
                    layers: {
                      ...(comboLayers || {}),
                      combo: {
                        settings: comboSettings,
                        index: idx,
                        id: comboId,
                      },
                    },
                  }}
                />
              )}
            </CarouselItemWrapper>
          ))}
        </div>
      </div>
    </div>
  );
});
